module.exports = __webpack_public_path__ + "img/logo.e312c5cf.png";